<template>
	<div class="search-form">
		<gc-custom-search
			width="300px"
			key-word-width="121px"
			:key-word-option="keyWordOption"
			:key-word.sync="keyWord"
			:search.sync="params.key"
		></gc-custom-search>
		<gc-custom-search
			v-for="item in searchFormItems"
			:key="item.prop"
			class="search"
			:type="item.type"
			:width="item.width"
			:key-word="item.keyWord"
			:filterable="item.filterable"
			:search-option="item.searchOption"
			:search-option-key="item.searchOptionKey"
			:search.sync="params[item.prop]"
			:need-all-for-search="item.needAllForSearch"
			:multiple="item.multiple"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { handleParams } from '@/utils'
import { isBlank } from '@/utils/validate'
import { generateSearchFormItems } from './config'

export default {
	name: 'SearchForm',
	data() {
		return {
			keyWordOption: [
				{
					label: '设备通讯编号',
					value: 'deviceNo',
				},
				{
					label: '外观编号',
					value: 'designNo',
				},
				{
					label: '用户号',
					value: 'userNo',
				},
				{
					label: '客户名称',
					value: 'userName',
				},
			],
			keyWord: 'deviceNo',
			params: {},
			searchOptions: {},
			searchFormItems: [],
		}
	},
	mounted() {
		this.updateSearchFormItems()
	},

	methods: {
		...mapActions({
			getDeviceTypes: 'common/getDeviceTypeList',
		}),

		async updateSearchFormItems() {
			this.searchFormItems = await this.initSearchFormItems()
		},

		async initSearchFormItems() {
			const res = await this.getDeviceTypeList()
			const list = this.dealRes(res)

			return generateSearchFormItems(list)
		},

		getSearchParams() {
			return handleParams({
				...this.params,
				[this.keyWord]: isBlank(this.params.key) ? undefined : this.params.key,
				key: undefined,
			})
		},

		resetSearchParams() {
			for (const key in this.params) {
				this.params[key] = null
			}
		},

		dealRes(list) {
			return list.map(item => ({ label: item.label, value: item.value }))
		},

		getDeviceTypeList() {
			return this.getDeviceTypes()
				.then(res => res)
				.catch(() => [])
		},
	},
}
</script>

<style scoped lang="scss">
.search-form {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
</style>
